export const POWER_PRICE_CHART_TO_PRINT_ID = 'power-price-chart-to-print'
